import Api from "../api";

export default async function apiDeleteDump(id: string) {
  return await Api.delete<string>({
    input: `/api/v1/dump/${id}`,
  });
}
